<template>
  <div class="action-plan-construction-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes do Serviço de Construção Civil</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50 row">
            <div v-if="!printing" class="col-6 col-xl-6">
              <!-- Arquivo de planta baixa -->
              <custom-file-uploader-box
                v-if="!printing"
                :title="'Upload de planta baixa do local'"
                @file-changed-event="setBlueprintFile"
              ></custom-file-uploader-box>

              <!-- Arquivo de projeto -->
              <custom-file-uploader-box
                v-if="!printing"
                class="mt-4"
                :title="'Upload de projeto'"
                @file-changed-event="setProjectFile"
              ></custom-file-uploader-box>

              <!-- Arquivo de imagem -->
              <custom-file-uploader-box
                v-if="!printing"
                class="mt-4"
                :title="'Upload de foto'"
                @file-changed-event="setPictureFile"
              ></custom-file-uploader-box>
            </div>

            <div class="col-12" :class="printing ? 'col-xl-12' : 'col-xl-6'">
              <div class="form-group">
                <label>Tipo de estrutura</label>
                <input
                  v-model="structureTypeResponse"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <custom-select-button
                  :title="''"
                  :options="structureTypeOptions"
                  v-model="structureTypeOption"
                />
              </div>

              <div class="form-group">
                <label>Maquinários / Equipamentos necessários</label>
                <input v-model="neededMachines" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label>Materiais necessários</label>
                <input v-model="neededMaterials" type="text" class="form-control" />
              </div>

              <div class="form-group">
                <label>Descrição detalhada do serviço</label>
                <textarea
                  v-model="serviceDetailedDescription"
                  type="text"
                  class="form-control"
                  rows="13"
                  style="height: 348px"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomSelectButton from '@/components/common/CustomSelectButton/CustomSelectButton.vue'
  import CustomFileUploaderBox from './components/CustomFileUploader'
  import { useRoute } from 'vue-router'
  import useSwal from '@/modules/Swal.js'

  const structureTypeOptions = [
    { label: 'Mobilização Montagem', value: 1 },
    {
      label: 'Desmobilização Desmontagem',
      value: 2,
    },
  ]

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showSuccessDialog } = useSwal()

      return {
        structureTypeOptions,
        showSuccessDialog,
        riskAnalysisDescriptionId,
      }
    },
    components: {
      CustomSelectButton,
      CustomFileUploaderBox,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,
        blueprintFile: null,
        projectFile: null,
        pictureFile: null,

        structureTypeResponse: '',
        structureTypeOption: 0,

        neededMachines: '',
        neededMaterials: '',
        serviceDetailedDescription: '',

        loading: false,
      }
    },
    methods: {
      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          needs_consultancy: this.consultancy,
          blueprint_file: this.blueprintFile,
          project_file: this.projectFile,
          picture_file: this.pictureFile,
          structure_type: this.structureTypeResponse,
          mobilization: this.structureTypeOption,
          equipments: this.neededMachines,
          materials: this.neededMaterials,
          description: this.serviceDetailedDescription,
        }

        let formData = new FormData()

        Object.keys(payload).forEach((field) =>
          formData.append(field, payload[field]),
        )

        this.axios
          .post(`/api/action-plan/services/construction`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => this.showSuccessDialog())
      },
      setBlueprintFile(event) {
        const file = event.file

        this.blueprintFile = file
      },
      setProjectFile(event) {
        const file = event.file

        this.projectFile = file
      },
      setPictureFile(event) {
        const file = event.file

        this.pictureFile = file
      },
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/construction`,
          )
          .then(({ data }) => {
            const service = data.construction_services[0]

            this.consultancy = data.needs_consultancy
            this.structureTypeResponse = service.structure_type
            this.structureTypeOption = service.mobilization
            this.neededMachines = service.equipments
            this.neededMaterials = service.materials
            this.serviceDetailedDescription = service.description
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    mounted() {
      this.load()
    },
  }
</script>
